import { render, staticRenderFns } from "./TaskFolder.vue?vue&type=template&id=2b017d1e&scoped=true&"
import script from "./TaskFolder.vue?vue&type=script&lang=js&"
export * from "./TaskFolder.vue?vue&type=script&lang=js&"
import style0 from "./TaskFolder.vue?vue&type=style&index=0&id=2b017d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b017d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAutocomplete,VIcon,VList,VListItem,VListItemTitle,VMenu,VTreeview})
